import { Spinner, SpinnerSize, Stack } from '@fluentui/react';
import React from 'react';

export const ChartLoading: React.FC = () => (
  <Stack grow verticalFill verticalAlign="center" horizontalAlign="center">
    <Spinner size={SpinnerSize.medium} />
  </Stack>
);
